import React, { Component } from "react";

class Social extends Component {
    render() {
        const url = 'https://www.byd.com/uk/electric-cars/ev-range-vs-footballer-endurance/';
        return (
            <div className="social">
                <ul>
                    <li><a href={'https://www.facebook.com/sharer/sharer.php?u='+url} aria-label="Facebook" className="icon facebook" target="_blank" rel="noreferrer"><span className="sr">Facebook</span></a></li>
                    <li><a href={'https://twitter.com/intent/tweet?text=Check+out+the+"EV+Range+vs+Football+Team+Endurance:+Who+outlasts+the+charge?"+by+BYD&url='+url} aria-label="X" className="icon x" target="_blank" rel="noreferrer"><span className="sr">X</span></a></li> 
                </ul>
            </div>
        );
    }
}

export default Social;